"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchText = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var react_select_1 = require("react-select");
var Types = require("types");
var sok_ui_2 = require("@caddigital/sok-ui/");
var userProjectsActions = require("@caddigital/sok-reducers/lib/actions/user/projects");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var List_1 = require("./List");
var constants_1 = require("utils/constants");
var Icon_1 = require("components/Icon");
require("./style.scss");
var timeout = null;
var mapStateToProps = function (state) {
    return {
        projects: state.user.projects
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToProps = function (dispatch) { return ({
    close: function () { return dispatch(userProjectsActions.clear()); },
    fetchUser: function (email) {
        return dispatch(userProjectsActions.fetchUserRequest(email));
    },
    selectUser: function (user) { return dispatch(userProjectsActions.selectUser(user)); },
    removeUser: function (user) { return dispatch(userProjectsActions.removeUser(user)); },
    copy: function () { return dispatch(userProjectsActions.copyProjectPermissions()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('tempValue', 'setTempValue', null), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
var getSearchText = function (status) {
    switch (status) {
        case 'FETCHING':
            return 'component/userProjectsModal/searching';
        case 'FETCHED':
            return 'component/userProjectsModal/noResults';
        case 'FAILED':
            return 'component/userProjectsModal/failed';
        default:
            return 'component/userProjectsModal/placeholder';
    }
};
exports.getSearchText = getSearchText;
var UserSelection = function (props) { return (React.createElement("div", { className: 'copy-projects' },
    React.createElement("div", { className: 'user-search' },
        React.createElement("label", { htmlFor: 'searchUser' }, (0, translation_1.getLocalization)('components/userProjects/searchUser')),
        React.createElement(react_select_1.default, { menuPlacement: 'top', classNamePrefix: "react-select", placeholder: (0, translation_1.getLocalization)('components/userProjects/searchUser'), id: 'searchUser', value: null, options: props.projects.users.length > 0 ? props.projects.users : [], isSearchable: true, getOptionValue: function (opt) { return opt.email; }, getOptionLabel: function (opt) { return opt.email; }, onChange: function (user) {
                user && !Array.isArray(user) && props.selectUser(user);
            }, isLoading: props.projects.usersStatus === 'FETCHING', noOptionsMessage: function () {
                return (0, translation_1.getLocalization)((0, exports.getSearchText)(props.projects.usersStatus));
            }, onInputChange: function (e) {
                props.setTempValue(e);
                if (timeout) {
                    clearTimeout(timeout);
                }
                timeout = setTimeout(function () {
                    e && props.fetchUser(e);
                    props.setTempValue(null);
                }, constants_1.SEARCH_TIMEOUT);
            } })),
    React.createElement("div", { className: 'emails', id: 'emails' },
        React.createElement("label", { htmlFor: 'emails' }, (0, translation_1.getLocalization)('components/userProjects/selectedUsers')),
        props.projects.selectedUsers.length > 0 &&
            props.projects.selectedUsers.map(function (u) { return (React.createElement("div", { className: 'email', key: u.id },
                React.createElement(sok_ui_1.TextInput, { value: u.email, editable: false, icon: React.createElement(Icon_1.Icon, { className: 'fa-times-circle', onClick: function () { return props.removeUser(u); } }) }))); })))); };
exports.default = enhance(function (props) {
    return (React.createElement(sok_ui_1.Modal, { className: 'user-project-modal', isOpen: props.projects.isOpen },
        React.createElement(sok_ui_1.RequestStatusBox, { status: props.projects.copyStatus, statusList: ['STANDBY', 'COPYING', 'COPIED', 'FAILURE'] },
            (0, translation_1.getLocalization)('components/userProjects/copying'),
            (0, translation_1.getLocalization)('components/userProjects/copied'),
            (0, translation_1.getLocalization)('components/userProjects/failed')),
        React.createElement(sok_ui_1.Header, { onClose: props.close }, (0, translation_1.getLocalization)('components/userProjects/header')),
        React.createElement(sok_ui_1.Container, null, props.projects.status === 'FETCHING' ? (React.createElement("div", { className: 'center-content' },
            React.createElement(sok_ui_2.LoadingSpinner, { key: 'spinner' }))) : props.projects.status === 'FETCHED' ? (React.createElement(React.Fragment, null,
            React.createElement(List_1.UserProjectsList, null),
            UserSelection(props))) : (React.createElement("div", { className: 'center-content' },
            React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('components/userProjects/error') })))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { color: 'blue', text: (0, translation_1.getLocalization)('components/userProjects/copyToUser'), onClick: props.copy, disabled: !props.projects.selectedUsers.length ||
                    !props.projects.selectedProjects.length }),
            React.createElement("a", { target: '_blank', href: props.projects.user
                    ? "".concat(__APIBASEURL__, "api/user/projects?user=").concat(props.projects.user.id, "&format=excel")
                    : '#' },
                React.createElement(sok_ui_1.Button, { color: 'base-green', text: (0, translation_1.getLocalization)('components/userProjects/createReport') })),
            React.createElement(sok_ui_1.Button, { color: 'base-green', text: (0, translation_1.getLocalization)('buttons/close'), onClick: props.close }))));
});
